import React, { useState, useEffect, useContext } from "react";

//Context
import { AuthContext } from '../../../../common/middlewares/Auth';

//Librerias
import { Controller } from "react-hook-form";
import { NumberFormatBase } from "react-number-format";
import "animate.css";

//Componentes de Material UI
import {
    Box,
    Paper,
    Grid,
    CircularProgress,
    Tooltip,
    Alert,
    AlertTitle,
    useTheme,
    useMediaQuery,
    TextField,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    FormHelperText,
    FormLabel,
} from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";

//Componentes
import DropdownEmpresasExternas from "./dropdownEmpresasExternas";
import DropdownSectorEmpresarial from "./dropdownSectorEmpresarial";
import DropdownBeneficios from "./dropdownBeneficios";
import DropdownCargosExternos from "./dropdownCargosExternos";
import SelectFuenteOferta from "./selectFuenteOferta";
import SelectPorqueSiVolveria from "./selectPorqueSiVolveria";
import SelectPorqueNoVolveria from "./selectPorqueNoVolveria";
import SelectMotivoRetiro from "./selectMotivoRetiro";
import SelectAspectoDestacar from "./selectAspectoDestacar";
import SelectAspectoMejorar from "./selectAspectoMejorar";
import SelectMejorChoucair from "./selectMejorChoucair";

const PaperVoluntaria = ({
    values,
    isTable,
    index,
    control,
    disabled,
    errors,
    getValues,
    required,
    remove,
    size,
    setValue,
    clearErrors,
    isPreview,
    sede
}) => {
    //===============================================================================================================================================
    //========================================== Context ============================================================================================
    //===============================================================================================================================================
    const { strInfoUser } = useContext(AuthContext);

    //===============================================================================================================================================
    //========================================== Declaracion de estados =============================================================================
    //===============================================================================================================================================
    const [data, setData] = useState({
        id: null,
        intId: null,
        strTipoRetiro: "",
        strMotivoRetiroUno: "",
        strMotivoRetiroDos: "",
        strObservacionRetiroUno: "",
        strObservacionRetiroDos: "",
        strAspectosMejorarJefeUno: "",
        strAspectosMejorarJefeDos: "",
        strObservacionMejorarJefe: "",
        strAspectosDestacarJefe: "",
        strObservacionDestacarJefe: "",
        strMejorChoucair: "",
        strObservacionMejorChoucair: "",
        strModeloLiderazgo: "",
        strIncentivoBuscarTrabajo: "",
        strNombreEmpresaTrabajar: "",
        strOtraNombreEmpresaTrabajar: "",
        strSectorEmpresaTrabajar: "",
        strOtraSectorEmpresaTrabajar: "",
        strBeneficiosOfrecidos: "",
        strCargoADesempeñar: "",
        strDondeLlegoOferta: "",
        strOtraDondeLlegoOferta: "",
        strSalarioOfrecido: "",
        strPrograma: "",
        strUniversidad: "",
        strObservacionRegreso: "",
        strComentarioAdicional: "",
        btVolveriaCHC: "",
        btRealizoEncuesta: "",
        dtFechaRetiro: null,
    });

    const [loading, setLoading] = useState(true);
    const [openCollapese, setOpenCollapse] = useState(true);
    const [openModalDelete, setOpenModalDelete] = useState(false);

    //===============================================================================================================================================
    //========================================== Hooks personalizados ===============================================================================
    //===============================================================================================================================================
    const theme = useTheme();
    const bitMobile = useMediaQuery(theme.breakpoints.down("sm"));

    //===============================================================================================================================================
    //========================================== Funciones ==========================================================================================
    //===============================================================================================================================================
    const handlerChangeOpenCollapse = () => {
        setOpenCollapse(!openCollapese);
    };

    const handlerChangeOpenModalDelete = () => {
        setOpenModalDelete(!openModalDelete);
    };

    //===============================================================================================================================================
    //========================================== useEffects =========================================================================================
    //===============================================================================================================================================
    useEffect(() => {
        setLoading(true);

        if (values) {
            setData({
                intId: values?.intId ?? null,
                intIdColaborador: values?.intIdColaborador ?? null,
                intIdColaboradorAdmin: values?.intIdColaboradorAdmin ?? null,
                strTipoRetiro: values?.strTipoRetiro ?? null,
                strMotivoRetiroUno: values?.strMotivoRetiroUno ?? null,
                strMotivoRetiroDos: values?.strMotivoRetiroDos ?? null,
                strObservacionRetiroUno: values?.strObservacionRetiroUno ?? null,
                strAspectosMejorarJefeUno: values?.strAspectosMejorarJefeUno ?? null,
                strObservacionMejorarJefe: values?.strObservacionMejorarJefe ?? null,
                strAspectosDestacarJefe: values?.strAspectosDestacarJefe ?? null,
                strRelacionEquipoTrabajo: values?.strRelacionEquipoTrabajo ?? null,
                btFuncionesClaras: values?.btFuncionesClaras ?? null,
                strFuncionesClarasPorque: values?.strFuncionesClarasPorque ?? null,
                btEspaciosFormales: values?.btEspaciosFormales ?? null,
                strAyudadoDesempeñarte: values?.strAyudadoDesempeñarte ?? null,
                btRecibisteApoyo: values?.btRecibisteApoyo ?? null,
                btIdentificadoCultura: values?.btIdentificadoCultura ?? null,
                strIdentificadoCuturaPorque: values?.strIdentificadoCuturaPorque ?? null,
                strMejorChoucair: values?.strMejorChoucair ?? null,
                strAspectoMejorarCH: values?.strAspectoMejorarCH ?? null,
                strObservacionMejorChoucair: values?.strObservacionMejorChoucair ?? "",
                strNombreEmpresaTrabajar: values?.strNombreEmpresaTrabajar ?? null,
                strSectorEmpresaTrabajar: values?.strSectorEmpresaTrabajar ?? null,
                strBeneficiosOfrecidos: values?.strBeneficiosOfrecidos ?? null,
                strCargoADesempeñar: values?.strCargoADesempeñar ?? null,
                strDondeLlegoOferta: values?.strDondeLlegoOferta ?? null,
                SalarioOfrecido: values?.SalarioOfrecido ?? null,
                strRangoSalarial: values?.strRangoSalarial ?? null,
                strProcesoComunicacionSalida: values?.strProcesoComunicacionSalida ?? null,
                strObservacionRegreso: values?.strObservacionRegreso ?? "",
                strComentarioAdicional: values?.strComentarioAdicional ?? "",
                btVolveriaCHC: values?.btVolveriaCHC ? "true" : "false",
                dtmActualizacion: values?.dtmActualizacion ?? null,
                btRealizoEncuesta: values?.btRealizoEncuesta ?? false,
                btEncuestaActiva: values?.btEncuestaActiva ?? true,
                strTipoEncuesta: values?.strTipoEncuesta ?? null,
                dtFechaRetiro: values?.dtFechaRetiro ?? null,
            });
        }

        setLoading(false);

        // eslint-disable-next-line
    }, [values]);

    //===============================================================================================================================================
    //========================================== Renders ============================================================================================
    //===============================================================================================================================================
    if (loading || !data.intId) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
            >
                <CircularProgress size={30} />
            </Box>
        );
    }

    if (!data.intId) {
        return (
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: {
                        xs: "column",
                        md: "row",
                    },
                    alignItems: {
                        xs: "flex-end",
                        md: "center",
                    },
                    marginBottom: "15px",
                }}
            >
                <Box sx={{ flexGrow: 1 }}>
                    <Alert severity="error" style={{ marginBottom: "15px" }}>
                        <AlertTitle>
                            <b>Se esperaba un identificador</b>
                        </AlertTitle>
                        Ha ocurrido un error al renderizar el formulario de
                        titulaciones
                    </Alert>
                </Box>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: {
                    xs: "column",
                    md: "row",
                },
                alignItems: {
                    xs: "flex-end",
                    md: "center",
                },
                marginBottom: "15px",
            }}
        >

            <Box sx={{ flexGrow: 1 }}>
                <Paper
                    style={{
                        backgroundColor: "#ffffff",
                        padding: "15px",
                    }}
                >
                    <Grid container direction="row" spacing={2}>
                        {isTable && (
                            <Grid item xs={12}>
                                <Controller
                                    name={`objEncuestaRetiro.dtFechaRetiro`}
                                    defaultValue={data.dtFechaRetiro}
                                    render={({ field: { name, value, onChange } }) => (
                                        <MobileDatePicker
                                            label="Fecha de retiro"
                                            value={value}
                                            name={name}
                                            format="dd/MM/yyyy"
                                            onChange={(e) => {
                                                onChange(e);
                                            }}
                                            slotProps={{
                                                textField: {
                                                    name: name,
                                                    fullWidth: true,
                                                    required: true,
                                                },
                                            }}
                                        />
                                    )}
                                    control={control}
                                />
                            </Grid>
                        )}
                        {/* Descripción del cargo que ocupo en la empresa o emplador */}
                        <Grid item xs={12}>
                            <Controller
                                name={`objEncuestaRetiro.strObservacionRetiroUno`}
                                defaultValue={data.strObservacionRetiroUno}
                                render={({
                                    field: { name, value, onChange },
                                }) => (
                                    <TextField
                                        label="¿Cuál es la razón principal por la que decidiste dejar la compañía?"
                                        name={name}
                                        value={value}
                                        disabled={disabled}
                                        multiline
                                        minRows={3}
                                        onChange={(e) => onChange(e)}
                                        fullWidth
                                        required
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strObservacionRetiroUno
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strObservacionRetiroUno?.message ||
                                            "Digita la observación de retiro"
                                        }
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, digita la observación de retiro",
                                    validate: (value) => {
                                        // Elimina espacios al inicio y final de cada línea
                                        let cleaned = value
                                            .split('\n') // separa por líneas
                                            .map(line => line.trim()) // elimina espacios en cada línea
                                            .filter(line => line.length > 0) // elimina líneas vacías
                                            .join(''); // une todo sin espacios
                                        if (cleaned.length <= 5) {
                                            return "La descripción de la observación de retiro es demasiado corta";
                                        }

                                    }
                                }}
                            />
                        </Grid>
                        {/* Motivo de retiro 1 */}
                        <Grid item xs={12}>
                            <Controller
                                name={`objEncuestaRetiro.strMotivoRetiroUno`}
                                defaultValue={data.strMotivoRetiroUno}
                                render={({ field: { name, onChange, value } }) => (
                                    <SelectMotivoRetiro
                                        label="Despliega la razón principal"
                                        name={name}
                                        value={value}
                                        onChange={(e) => {
                                            onChange(e)
                                            setData((prevState) => ({
                                                ...prevState,
                                                strMotivoRetiroUno: e.target.value,
                                            }));
                                        }}
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strMotivoRetiroUno
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strMotivoRetiroUno?.message ||
                                            "Selecciona el motivo del retiro de la compañía"
                                        }
                                        disabled={disabled}
                                        fullWidth
                                        required
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, selecciona el motivo del retiro de la compañía",
                                }}
                            />
                        </Grid>
                        {/* Nombre de la empresa */}
                        <Grid item xs={12}>
                            <Alert
                                severity="info"
                            >
                                <AlertTitle>
                                    <b>Importante</b>
                                </AlertTitle>
                                Si tu respuesta anterior fue por Salario, Crecimiento profesional o Beneficios ofrecidos.
                            </Alert>
                        </Grid>
                        <Grid item xs={12} md={data.strNombreEmpresaTrabajar === "Otra ¿cuál?" ? 6 : null}>
                            <Controller
                                name="objEncuestaRetiro.strNombreEmpresaTrabajar"
                                defaultValue={data.strNombreEmpresaTrabajar}
                                render={({
                                    field: { name, value, onChange },
                                }) => (
                                    <DropdownEmpresasExternas
                                        label="Cuéntanos el nombre empresa que te realizó la oferta"
                                        name={name}
                                        value={value}
                                        disabled={disabled}
                                        onChange={(e, value) => {
                                            console.log(value);
                                            onChange(value)
                                            setData((prevState) => ({
                                                ...prevState,
                                                strNombreEmpresaTrabajar: value,
                                            }));
                                        }}
                                        required
                                        error={
                                            !!errors?.objEncuestaRetiro?.strNombreEmpresaTrabajar
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro?.strNombreEmpresaTrabajar?.message ||
                                            "Selecciona la empresa que te realizó la oferta"
                                        }
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, selecciona la empresa que te realizó la oferta",
                                }}
                            />
                        </Grid>
                        {data.strNombreEmpresaTrabajar === "Otra ¿cuál?" ? <Grid item xs={6}>
                            <Controller
                                name="objEncuestaRetiro.strOtraNombreEmpresaTrabajar"
                                defaultValue={data.strOtraNombreEmpresaTrabajar}
                                render={({
                                    field: { name, value, onChange },
                                }) => (
                                    <TextField
                                        label="¿Cual?"
                                        name={name}
                                        value={value}
                                        disabled={disabled}
                                        onChange={(e) => onChange(e)}
                                        fullWidth
                                        required
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strOtraNombreEmpresaTrabajar
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strOtraNombreEmpresaTrabajar?.message ||
                                            "Digita la otra empresa que te realizó la oferta"
                                        }
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, digita la otra empresa que te realizó la oferta",
                                    validate: (value) => {
                                        if (value?.length >= 100) {
                                            return "El nombre de la empresa es demasiado largo."
                                        }
                                        // Elimina espacios al inicio y final de cada línea
                                        let cleaned = value
                                            ?.split('\n') // separa por líneas
                                            ?.map(line => line.trim()) // elimina espacios en cada línea
                                            ?.filter(line => line.length > 0) // elimina líneas vacías
                                            ?.join(''); // une todo sin espacios
                                        if (cleaned?.length <= 5) {
                                            return "El nombre de la empresa es demasiado corto";
                                        }
                                    }
                                }}
                            />
                        </Grid> : null}
                        {/* Sector de la empresa */}
                        <Grid item xs={12} md={data.strSectorEmpresaTrabajar === "Otra ¿cuál?" ? 6 : null}>
                            <Controller
                                name="objEncuestaRetiro.strSectorEmpresaTrabajar"
                                defaultValue={data.strSectorEmpresaTrabajar}
                                render={({
                                    field: { name, value, onChange },
                                }) => (
                                    <DropdownSectorEmpresarial
                                        label="Cuéntanos a que sector pertenece la empresa que te realizó la oferta"
                                        name={name}
                                        value={value}
                                        disabled={disabled}
                                        onChange={(e, value) => {
                                            onChange(value)
                                            setData((prevState) => ({
                                                ...prevState,
                                                strSectorEmpresaTrabajar: value,
                                            }));
                                        }}
                                        required={data.strNombreEmpresaTrabajar !== "No va para otra organización" ? true : false}
                                        error={
                                            !!errors?.objEncuestaRetiro?.strSectorEmpresaTrabajar
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro?.strSectorEmpresaTrabajar?.message ||
                                            "Selecciona el sector de la empresa que te realizó la oferta"
                                        }
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: data.strNombreEmpresaTrabajar !== "No va para otra organización" ? "Por favor, selecciona el sector de la empresa que te realizó la oferta" : null,
                                }}
                            />
                        </Grid>
                        {data.strSectorEmpresaTrabajar === "Otra ¿cuál?" ? <Grid item xs={6}>
                            <Controller
                                name="objEncuestaRetiro.strOtraSectorEmpresaTrabajar"
                                defaultValue={data.strOtraSectorEmpresaTrabajar}
                                render={({
                                    field: { name, value, onChange },
                                }) => (
                                    <TextField
                                        label="¿Cual?"
                                        name={name}
                                        value={value}
                                        disabled={disabled}
                                        onChange={(e) => onChange(e)}
                                        fullWidth
                                        required
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strOtraSectorEmpresaTrabajar
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strOtraSectorEmpresaTrabajar?.message ||
                                            "Digita el otro sector de la empresa que te realizó la oferta"
                                        }
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, digita el otro sector de la empresa que te realizó la oferta",
                                    validate: (value) => {
                                        if (value?.length >= 100) {
                                            return "El sector de la empresa es demasiado largo."
                                        }
                                        // Elimina espacios al inicio y final de cada línea
                                        let cleaned = value
                                            ?.split('\n') // separa por líneas
                                            ?.map(line => line.trim()) // elimina espacios en cada línea
                                            ?.filter(line => line.length > 0) // elimina líneas vacías
                                            ?.join(''); // une todo sin espacios
                                        if (cleaned?.length <= 5) {
                                            return "El sector de la empresa es demasiado corto";
                                        }
                                    }
                                }}
                            />
                        </Grid> : null}
                        {/* Salario ofrecido */}
                        <Grid item xs={12} md={6}>
                            <Controller
                                defaultValue={data.SalarioOfrecido}
                                name="objEncuestaRetiro.SalarioOfrecido"
                                render={({
                                    field: { name, value, onChange },
                                }) => (
                                    <NumberFormatBase
                                        label="¿Cual fue el salario ofrecido?"
                                        name={name}
                                        customInput={TextField}
                                        value={value}
                                        onChange={(e) => onChange(e)}
                                        disabled={isPreview ? true : disabled}
                                        fullWidth
                                        required={data.strNombreEmpresaTrabajar !== "No va para otra organización" ? true : false}
                                        error={errors?.objEncuestaRetiro?.SalarioOfrecido ? true : false}
                                        helperText={
                                            errors?.objEncuestaRetiro?.SalarioOfrecido?.message ||
                                            "Digita el salario ofrecido por la otra empresa"
                                        }
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: data.strNombreEmpresaTrabajar !== "No va para otra organización" ? "Por favor, digita el salario ofrecido por la otra empresa" : null,
                                    validate: (value) => {
                                        // Extraer solo números del value
                                        const numericValue = parseFloat((value || '').toString().replace(/[^\d.-]/g, ''));

                                        // Validar que sea un número válido
                                        if (isNaN(numericValue)) {
                                            return "Por favor ingresa un salario válido";
                                        }

                                        // Validar límite del tipo money en SQL Server
                                        if (numericValue > 922337203685477.58) {
                                            return "El salario excede el límite permitido";
                                        }
                                    }
                                }}
                            />
                        </Grid>
                        {/* Cargo a desempeñar*/}
                        <Grid item xs={12} md={6}>
                            <Controller
                                name={`objEncuestaRetiro.strCargoADesempeñar`}
                                defaultValue={data.strCargoADesempeñar}
                                render={({
                                    field: { name, value, onChange },
                                }) => (
                                    <DropdownCargosExternos
                                        label="¿Qué cargo vas a desempeñar en la nueva compañía?"
                                        name={name}
                                        value={value}
                                        disabled={disabled}
                                        onChange={(e, value) => {
                                            onChange(value)
                                            setData((prevState) => ({
                                                ...prevState,
                                                strCargoADesempeñar: value,
                                            }));
                                        }}
                                        fullWidth
                                        required={data.strNombreEmpresaTrabajar !== "No va para otra organización" ? true : false}
                                        error={
                                            !!errors?.objEncuestaRetiro?.strCargoADesempeñar
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro?.strCargoADesempeñar?.message ||
                                            "Por favor si no encuentra el nombre del cargo especifico, seleccionar el que más se asemeja."
                                        }
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: data.strNombreEmpresaTrabajar !== "No va para otra organización" ? "Por favor, selecciona el cargo a desempeñar en la otra empresa" : null,
                                }}
                            />
                        </Grid>
                        {/* Beneficios de la otra empresa */}
                        <Grid item xs={12}>
                            <Controller
                                name={`objEncuestaRetiro.arrBeneficios`}
                                defaultValue={data.arrBeneficios}
                                render={({
                                    field: { name, value, onChange },
                                }) => (
                                    <DropdownBeneficios
                                        label="Aparte de mejor oferta salarial ¿Que otros beneficios te ofrecieron?"
                                        name={name}
                                        value={value}
                                        multiple
                                        required={data.strNombreEmpresaTrabajar !== "No va para otra organización" ? true : false}
                                        disabled={disabled}
                                        onChange={(e, value) => {
                                            onChange(value)
                                            setData((prevState) => ({
                                                ...prevState,
                                                arrBeneficios: value?.map((objCono) => objCono?.intId),
                                            }));
                                        }}
                                        fullWidth
                                        error={
                                            !!errors?.objEncuestaRetiro?.arrBeneficios
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro?.arrBeneficios?.message ||
                                            "Selecciona los beneficios ofrecidos por la otra empresa, selecciona máximo 3"
                                        }
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: data.strNombreEmpresaTrabajar !== "No va para otra organización" ? "Por favor, selecciona los beneficios ofrecidos por la otra empresa" : null,
                                    validate: (value) => {
                                        if (value?.length > 3) {
                                            return "Solo puedes seleccionar un maximo de 3 beneficios."
                                        }
                                    }
                                }}
                            />
                        </Grid>
                        {/* Fuente de la oferta laboral */}
                        <Grid item xs={12} md={data.strDondeLlegoOferta === "Otra" ? 6 : null}>
                            <Controller
                                defaultValue={data.strDondeLlegoOferta}
                                name="objEncuestaRetiro.strDondeLlegoOferta"
                                render={({ field: { name, onChange, value } }) => (
                                    <SelectFuenteOferta
                                        label="¿Cuéntanos porque medio te llego la oferta laboral?"
                                        name={name}
                                        value={value}
                                        error={
                                            errors?.objEncuestaRetiro
                                                ?.strDondeLlegoOferta
                                                ? true
                                                : false
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strDondeLlegoOferta?.message ||
                                            "Selecciona la fuente por donde le llego la oferta laboral"
                                        }
                                        onChange={(e) => {
                                            onChange(e)
                                            setData((prevState) => ({
                                                ...prevState,
                                                strDondeLlegoOferta: e.target.value,
                                            }));
                                        }}
                                        disabled={isPreview ? true : disabled}
                                        required={data.strNombreEmpresaTrabajar !== "No va para otra organización" ? true : false}
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: data.strNombreEmpresaTrabajar !== "No va para otra organización" ? "Por favor, selecciona la fuente por donde le llego la oferta laboral" : null
                                }}
                            />
                        </Grid>
                        {data.strDondeLlegoOferta === "Otra" ? <Grid item xs={6}>
                            <Controller
                                name="objEncuestaRetiro.strOtraDondeLlegoOferta"
                                defaultValue={data.strOtraDondeLlegoOferta}
                                render={({
                                    field: { name, value, onChange },
                                }) => (
                                    <TextField
                                        label="¿Cual?"
                                        name={name}
                                        value={value}
                                        disabled={disabled}
                                        onChange={(e) => onChange(e)}
                                        fullWidth
                                        required
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strOtraDondeLlegoOferta
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strOtraDondeLlegoOferta?.message ||
                                            "Digita la otra fuente por donde le llego la oferta laboral"
                                        }
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, digita la otra fuente por donde le llego la oferta laboral",
                                    validate: (value) => {
                                        if (value?.length >= 100) {
                                            return "La fuente por donde le llego la oferta es demasiada larga."
                                        }
                                        // Elimina espacios al inicio y final de cada línea
                                        let cleaned = value
                                            ?.split('\n') // separa por líneas
                                            ?.map(line => line.trim()) // elimina espacios en cada línea
                                            ?.filter(line => line.length > 0) // elimina líneas vacías
                                            ?.join(''); // une todo sin espacios
                                        if (cleaned?.length <= 5) {
                                            return "La fuente por donde le llego la oferta es demasiada corta";
                                        }
                                    }
                                }}
                            />
                        </Grid> : null}
                        {/* Lo mejor de Choucair */}
                        <Grid item xs={12}>
                            <Controller
                                name={`objEncuestaRetiro.strMejorChoucair`}
                                defaultValue={data.strMejorChoucair}
                                render={({ field: { name, onChange, value } }) => (
                                    <SelectMejorChoucair
                                        label="Teniendo en cuenta tu experiencia en Choucair, ¿Qué fue lo mejor de tu viaje en esta compañía?"
                                        name={name}
                                        value={value}
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strMejorChoucair
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strMejorChoucair?.message ||
                                            "Selecciona lo mejor de la compañía"
                                        }
                                        onChange={(e) => onChange(e)}
                                        disabled={disabled}
                                        fullWidth
                                        required
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, selecciona lo mejor de la compañía"
                                }}
                            />
                        </Grid>
                        {/* cultura de confianza */}
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        defaultValue={data.btIdentificadoCultura}
                                        name="objEncuestaRetiro.btIdentificadoCultura"
                                        render={({ field: { name, onChange, value } }) => (
                                            <FormControl disabled={disabled} error={errors?.btIdentificadoCultura}>
                                                <FormLabel>¿Sentiste que la cultura de confianza se vivió en tu día a día?
                                                    <br />(Confianza: coherencia entre palabras, acciones y resultados)</FormLabel>
                                                <RadioGroup
                                                    row
                                                    value={value}
                                                    name={name}
                                                    onChange={(e) => {
                                                        onChange(e)
                                                        setData((prevState) => ({
                                                            ...prevState,
                                                            btIdentificadoCultura: e.target.value
                                                        }))
                                                    }}
                                                >
                                                    <FormControlLabel disabled={disabled} value={true} control={<Radio disabled={loading} />} label="Si" />
                                                    <FormControlLabel disabled={disabled} value={false} control={<Radio disabled={loading} />} label="No" />
                                                </RadioGroup>
                                                <FormHelperText error={errors?.objEncuestaRetiro?.btIdentificadoCultura}>
                                                    {errors?.objEncuestaRetiro?.btIdentificadoCultura?.message || "Por favor, selecciona un opción"}
                                                </FormHelperText>
                                            </FormControl>
                                        )}
                                        control={control}
                                        rules={{
                                            validate: (value) => {
                                                if (value === null) {
                                                    return "Por favor, selecciona un opción";
                                                }
                                            }
                                        }}
                                    />
                                </Grid>
                                {/* Descripción del cargo que ocupo en la empresa o emplador */}
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        name={`objEncuestaRetiro.strIdentificadoCuturaPorque`}
                                        defaultValue={data.strIdentificadoCuturaPorque}
                                        render={({
                                            field: { name, value, onChange },
                                        }) => (
                                            <TextField
                                                label="¿Por qué?"
                                                name={name}
                                                value={value}
                                                disabled={disabled}
                                                multiline
                                                minRows={3}
                                                onChange={(e) => onChange(e)}
                                                fullWidth
                                                required
                                                error={
                                                    !!errors?.objEncuestaRetiro
                                                        ?.strIdentificadoCuturaPorque
                                                }
                                                helperText={
                                                    errors?.objEncuestaRetiro
                                                        ?.strIdentificadoCuturaPorque?.message ||
                                                    "Digita la observación del por qué"
                                                }
                                            />
                                        )}
                                        control={control}
                                        rules={{
                                            required: "Por favor, digita la observación del por qué",
                                            validate: (value) => {
                                                // Elimina espacios al inicio y final de cada línea
                                                let cleaned = value
                                                    .split('\n') // separa por líneas
                                                    .map(line => line.trim()) // elimina espacios en cada línea
                                                    .filter(line => line.length > 0) // elimina líneas vacías
                                                    .join(''); // une todo sin espacios
                                                if (cleaned.length <= 5) {
                                                    return "La descripción de la observación es demasiado corta";
                                                }

                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* Vovleria a CH */}
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        defaultValue={data.btVolveriaCHC}
                                        name="objEncuestaRetiro.btVolveriaCHC"
                                        render={({ field: { name, onChange, value } }) => (
                                            <FormControl disabled={disabled} error={errors?.btVolveriaCHC}>
                                                <FormLabel>Teniendo en cuenta tu experiencia en Choucair, ¿Volvería a trabajar con nosotros?</FormLabel>
                                                <RadioGroup
                                                    row
                                                    value={value}
                                                    name={name}
                                                    onChange={(e) => {
                                                        onChange(e)
                                                        setData((prevState) => ({
                                                            ...prevState,
                                                            btVolveriaCHC: e.target.value
                                                        }))
                                                        console.log(e.target.value);
                                                    }}
                                                >
                                                    <FormControlLabel disabled={disabled} value={true} control={<Radio disabled={loading} />} label="Si" />
                                                    <FormControlLabel disabled={disabled} value={false} control={<Radio disabled={loading} />} label="No" />
                                                </RadioGroup>
                                                <FormHelperText error={errors?.objEncuestaRetiro?.btVolveriaCHC}>
                                                    {errors?.objEncuestaRetiro?.btVolveriaCHC?.message || "Por favor, selecciona un opción"}
                                                </FormHelperText>
                                            </FormControl>
                                        )}
                                        control={control}
                                        rules={{
                                            validate: (value) => {
                                                if (value === null) {
                                                    return "Por favor, selecciona un opción";
                                                }
                                            }
                                        }}
                                    />
                                </Grid>

                                {/* Observacion regreso */}
                                {data.btVolveriaCHC === "true" ? (
                                    <Grid item xs={12} md={6}>
                                        <Controller
                                            name={`objEncuestaRetiro.strObservacionRegreso`}
                                            defaultValue={data.strObservacionRegreso}
                                            render={({ field: { name, onChange, value } }) => (
                                                <SelectPorqueSiVolveria
                                                    label="Por qué volvería a Choucair"
                                                    name={name}
                                                    value={value}
                                                    error={
                                                        !!errors?.objEncuestaRetiro
                                                            ?.strObservacionRegreso
                                                    }
                                                    helperText={
                                                        errors?.objEncuestaRetiro
                                                            ?.strObservacionRegreso?.message ||
                                                        "Selecciona el porque si volvería a la compañía"
                                                    }
                                                    onChange={(e) => onChange(e)}
                                                    disabled={disabled}
                                                    fullWidth
                                                    required
                                                />
                                            )}
                                            control={control}
                                            rules={{
                                                required: "Por favor, selecciona el porque si volvería a la compañía"
                                            }}
                                        />
                                    </Grid>
                                ) : null}
                                {data.btVolveriaCHC === "false" ? (
                                    <Grid item xs={12} md={6}>
                                        <Controller
                                            name={`objEncuestaRetiro.strObservacionRegreso`}
                                            defaultValue={data.strObservacionRegreso}
                                            render={({ field: { name, onChange, value } }) => (
                                                <SelectPorqueNoVolveria
                                                    label="Por qué no volvería a Choucair"
                                                    name={name}
                                                    value={value}
                                                    error={
                                                        !!errors?.objEncuestaRetiro
                                                            ?.strObservacionRegreso
                                                    }
                                                    helperText={
                                                        errors?.objEncuestaRetiro
                                                            ?.strObservacionRegreso?.message ||
                                                        "Selecciona el porque no volvería a la compañía"
                                                    }
                                                    onChange={(e) => onChange(e)}
                                                    disabled={disabled}
                                                    fullWidth
                                                    required
                                                />
                                            )}
                                            control={control}
                                            rules={{
                                                required: "Por favor, selecciona el porque no volvería a la compañía"
                                            }}
                                        />
                                    </Grid>
                                ) : null}
                            </Grid>
                        </Grid>
                        {/* Recomendarias la compañia */}
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        defaultValue={data.btRecomendariasCompañia}
                                        name="objEncuestaRetiro.btRecomendariasCompañia"
                                        render={({ field: { name, onChange, value } }) => (
                                            <FormControl disabled={disabled} error={errors?.btRecomendariasCompañia}>
                                                <FormLabel>Teniendo en cuenta tu experiencia en Choucair, ¿Recomendarías esta compañía para trabajar?</FormLabel>
                                                <RadioGroup
                                                    row
                                                    value={value}
                                                    name={name}
                                                    onChange={(e) => {
                                                        onChange(e)
                                                        setData((prevState) => ({
                                                            ...prevState,
                                                            btRecomendariasCompañia: e.target.value
                                                        }))
                                                    }}
                                                >
                                                    <FormControlLabel disabled={disabled} value={true} control={<Radio disabled={loading} />} label="Si" />
                                                    <FormControlLabel disabled={disabled} value={false} control={<Radio disabled={loading} />} label="No" />
                                                </RadioGroup>
                                                <FormHelperText error={errors?.objEncuestaRetiro?.btRecomendariasCompañia}>
                                                    {errors?.objEncuestaRetiro?.btRecomendariasCompañia?.message || "Por favor, selecciona un opción"}
                                                </FormHelperText>
                                            </FormControl>
                                        )}
                                        control={control}
                                        rules={{
                                            validate: (value) => {
                                                if (value === null) {
                                                    return "Por favor, selecciona un opción";
                                                }
                                            }
                                        }}
                                    />
                                </Grid>
                                {/* Descripción del cargo que ocupo en la empresa o emplador */}
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        name={`objEncuestaRetiro.strRecomendariasCompañiaPorque`}
                                        defaultValue={data.strRecomendariasCompañiaPorque}
                                        render={({
                                            field: { name, value, onChange },
                                        }) => (
                                            <TextField
                                                label="¿Por qué?"
                                                name={name}
                                                value={value}
                                                disabled={disabled}
                                                multiline
                                                minRows={3}
                                                onChange={(e) => onChange(e)}
                                                fullWidth
                                                required
                                                error={
                                                    !!errors?.objEncuestaRetiro
                                                        ?.strRecomendariasCompañiaPorque
                                                }
                                                helperText={
                                                    errors?.objEncuestaRetiro
                                                        ?.strRecomendariasCompañiaPorque?.message ||
                                                    "Digita la observación del por qué"
                                                }
                                            />
                                        )}
                                        control={control}
                                        rules={{
                                            required: "Por favor, digita la observación del por qué",
                                            validate: (value) => {
                                                // Elimina espacios al inicio y final de cada línea
                                                let cleaned = value
                                                    .split('\n') // separa por líneas
                                                    .map(line => line.trim()) // elimina espacios en cada línea
                                                    .filter(line => line.length > 0) // elimina líneas vacías
                                                    .join(''); // une todo sin espacios
                                                if (cleaned.length <= 5) {
                                                    return "La descripción de la observación es demasiado corta";
                                                }

                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* Aspecto a destacar */}
                        <Grid item xs={12} md={6}>
                            <Controller
                                name={`objEncuestaRetiro.strAspectosDestacarJefe`}
                                defaultValue={data.strAspectosDestacarJefe}
                                render={({ field: { name, onChange, value } }) => (
                                    <SelectAspectoDestacar
                                        label="Teniendo en cuenta tu experiencia en Choucair, ¿Qué destacas de tu líder Choucair?"
                                        name={name}
                                        value={value}
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strAspectosDestacarJefe
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strAspectosDestacarJefe?.message ||
                                            "Selecciona lo que mas destacas de tu líder"
                                        }
                                        onChange={(e) => onChange(e)}
                                        disabled={disabled}
                                        fullWidth
                                        required
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, selecciona lo que mas destacas de tu líder"
                                }}
                            />
                        </Grid>
                        {/* Aspecto a mejorar */}
                        <Grid item xs={12} md={6}>
                            <Controller
                                name={`objEncuestaRetiro.strAspectosMejorarJefeUno`}
                                defaultValue={data.strAspectosMejorarJefeUno}
                                render={({ field: { name, onChange, value } }) => (
                                    <SelectAspectoMejorar
                                        label="Teniendo en cuenta tu experiencia en Choucair, ¿Qué mejorarías de tu líder Choucair?"
                                        name={name}
                                        value={value}
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strAspectosMejorarJefeUno
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strAspectosMejorarJefeUno?.message ||
                                            "Selecciona lo que puede mejorar de tu líder"
                                        }
                                        onChange={(e) => onChange(e)}
                                        disabled={disabled}
                                        fullWidth
                                        required
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, selecciona lo que puede mejorar de tu líder"
                                }}
                            />
                        </Grid>
                        {/* Comentario adicional */}
                        <Grid item xs={12}>
                            <Controller
                                name={`objEncuestaRetiro.strComentarioAdicional`}
                                defaultValue={data.strComentarioAdicional}
                                render={({
                                    field: { name, value, onChange },
                                }) => (
                                    <TextField
                                        label="Tu opinión es muy importante para nosotros, cuéntanos si nos quieres expresar algo adicional de tu experiencia en Choucair."
                                        name={name}
                                        value={value}
                                        disabled={disabled}
                                        multiline
                                        minRows={3}
                                        onChange={(e) => onChange(e)}
                                        fullWidth
                                        required
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strComentarioAdicional
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strComentarioAdicional?.message ||
                                            "Digita un comentario adicional"
                                        }
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, digita un comentario adicional",
                                    validate: (value) => {
                                        // Elimina espacios al inicio y final de cada línea
                                        let cleaned = value
                                            ?.split('\n') // separa por líneas
                                            ?.map(line => line.trim()) // elimina espacios en cada línea
                                            ?.filter(line => line.length > 0) // elimina líneas vacías
                                            ?.join(''); // une todo sin espacios
                                        if (cleaned?.length <= 5) {
                                            return "El comentario adicional es demasiado corto";
                                        }
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>

                </Paper>
            </Box>
        </Box>
    );
};

export default PaperVoluntaria;
